import { useState, useEffect, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { CarritoContext } from '../context/carritoContext'
import CalificacionProducto from '../publicaciones/calificacionProducto/CalificacionProducto'
import Descripcion from '../publicaciones/Descripcion'
import DetalleCabecera from '../publicaciones/DetalleCabecera'
import InformacionVendedor from '../publicaciones/InformacionVendedor'
import Metadatos from '../publicaciones/Metadatos'
import { MensajeriaNew } from '../reutilizables/mensajeria/MensajeriaNew'
import * as calificacionService from '../servicios/calificacionService'
import * as mensajesService from '../servicios/mensajesService'
import * as publicacionesService from '../servicios/publicacionesService'
import * as reputacionService from '../servicios/reputacionService'
import BordeDetalle from '../ui/BordeDetalle'
import styles from './PublicacionDetalle.module.css'

export const PublicacionDetalle = () => {
  const usuario = parseInt(localStorage.getItem('idUsuario'))
  const { id } = useParams()
  const navigate = useNavigate()
  const [publicacion, setPublicacion] = useState([])
  const [reputacion, setReputacion] = useState(0)
  const [calificacion, setCalificacion] = useState(0)
  const [mensajes, setMensajes] = useState([])
  const { setCantidadCompra } = useContext(CarritoContext)

  const buscarMensajes = async () => {
    const { data } = await mensajesService.buscarPorPublicacion(id)
    setMensajes(data.sort((a, b) => new Date(b.fechaEscrito) - new Date(a.fechaEscrito)))
  }

  const obtenerPublicacion = async () => {
    const publicacionRes = await publicacionesService.buscarDetalle(id)
    setPublicacion(publicacionRes.data)

    const reputacionRes = await reputacionService.buscarReputacion(
      publicacionRes.data.idVendedor
    )
    setReputacion(reputacionRes.data)

    const calificacionRes = await calificacionService.buscarCalificacion(id)
    setCalificacion(calificacionRes.data)

    await buscarMensajes()
  }

  useEffect(() => {
    obtenerPublicacion()
    setCantidadCompra(1)
  }, [id])

  const onCerrarClick = () => {
    navigate(-1)
    setCantidadCompra(1)
  }

  return (
    <BordeDetalle titulo={'Detalle Publicación'} onCerrarClick={() => onCerrarClick()}>
      <DetalleCabecera detalle={publicacion} />
      <Descripcion descripcion={publicacion?.descripcion} />
      <Metadatos idPublicacion={publicacion?.idPublicacion} />
      <div className={styles.flexContainer}>
        <MensajeriaNew
          titulo={'Preguntas'}
          id={id}
          tipoDoc={'publicacion'}
          idVendedor={publicacion?.idVendedor}
          mensajes={mensajes}
          tipoMensajes={'preguntas'}
          usuario={usuario}
          idComprador={usuario}
          actualizarMensajes={buscarMensajes}
        />
        <InformacionVendedor
          reputacion={reputacion.length > 0 ? reputacion : 0}
          publicacion={publicacion}
        />
      </div>

      {calificacion.length > 0 && <CalificacionProducto calificacion={calificacion} />}
    </BordeDetalle>
  )
}
